<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ props }">
      <v-btn color="primary" dark class="mb-2" v-bind="props">{{ $t('meta.addCategory') }}</v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ $t('meta.addNewCategory') }}</span>
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="addCategory" ref="form">
          <v-text-field v-model="category.genre_id" :label="$t('meta.genreId')" type="number" required></v-text-field>
          <v-text-field v-model="category.name" :label="$t('meta.name')" required></v-text-field>
          <v-text-field v-model="category.category_index" :label="$t('meta.index')" type="number" required></v-text-field>
          <v-text-field v-model="category.code" :label="$t('meta.code')" required></v-text-field>
          <v-text-field v-model="category.criteria_mapping" :label="$t('meta.criteriaMapping')" required></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">{{ $t('meta.cancel') }}</v-btn>
        <v-btn color="blue darken-1" text @click="addCategory">{{ $t('meta.add') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import { useI18n } from 'vue-i18n'

const { t: $t } = useI18n()

const emit = defineEmits(['category-added'])

const dialog = ref(false)
const category = ref({
  genre_id: null,
  name: '',
  category_index: null,
  code: '',
  criteria_mapping: ''
})

async function addCategory() {
  try {
    await axios.post('/api/categories', category.value)
    emit('category-added')
    dialog.value = false
    category.value = {
      genre_id: null,
      name: '',
      category_index: null,
      code: '',
      criteria_mapping: ''
    }
  } catch (error) {
    console.error('Error adding category:', error)
  }
}
</script>

<i18n>
{
  "en": {
    "meta": {
      "genreId": "Genre ID"
    }
  },
  "zh": {
    "meta": {
      "genreId": "流派ID"
    }
  }
}
</i18n>